import React, { useEffect, useState, useRef } from "react";
import { Table, Row, Col, Button, Modal, Spinner, Form } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import SendMultipleMsg from "./SendMultipleMsg";
import { setMultiMsg } from "../Common/ActiveKeySlice";
import TableSkeleton from "../Common/TableSkeleton";
import moment from "moment";
import useApiCall from "../../Hooks/useApiCall";
import pdfIcon from "../../Assets/pdf.svg";
import videoIcon from "../../Assets/video.svg";

export const ViewSingleTemplate = () => {
  const userState = useSelector((state) => state?.loginData?.userData?.data);

  const { apiCall } = useApiCall();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const templateData = location?.state?.data;
  const userData = useSelector((state) => state?.loginData?.userData?.data);
  const multiMsg = useSelector((state) => state.activeData?.activeMultiMsg);

  const [loader, setLoader] = useState(false);
  const [medialoader, setMediaLoader] = useState(false);
  const [templateLoader, setTemplateLoader] = useState(false);
  const [data, setData] = useState();
  const [show, setShow] = useState(false);
  const [showReject, setShowReject] = useState(false);
  const [showSendMsg, setShowSendMsg] = useState(false);
  const [consumer, setConsumer] = useState();
  const [consumerList, setconsumerList] = useState([]);
  const [status, setStatus] = useState("Pending");
  const [variables, setVariables] = useState([]);
  const [filename,setFileName] = useState("")

  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB in bytes

  useEffect(() => {
    if (data) {
      setVariables(data.variable || []);
    }
  }, [data]);

  // error states
  const [statusErr, setStatusErr] = useState(false);
  const [consumerErr, setConsumerErr] = useState(false);
  const [variableErrors, setVariableErrors] = useState(
    new Array(variables.length).fill(false)
  );

  useEffect(() => {
    getAllConsumer();
  }, []);

  // get All consumer ----------------
  const getAllConsumer = async () => {
    try {
      const response = await apiCall({
        apiGroup: "consumer",
        apiRoute: "getConsumers",
        queryParams: `searchField=&pageNo=${1}&docPerPage=${20}&departmentId=${
          userState?.departmentId
        }`,
      });

      setconsumerList(response.data.consumers);
      setLoader(false);
    } catch (err) {
      console.log("Error while getting users", err);
      setLoader(false);
    }

    // await fetch(process.env.REACT_APP_BASE_URL + `/consumer?searchField=&pageNo=${1}&docPerPage=${20}`,{
    //     method:'GET'
    // }).then((res)=>res.json()).then((response)=>{
    //     setconsumerList(response.data.consumers);
    //     setLoader(false);
    // }).catch((err)=>{
    //     console.log("Error while getting users", err);
    //     setLoader(false);
    // })
  };

  const consumerData =
    consumerList !== undefined &&
    consumerList !== null &&
    consumerList.length > 0
      ? consumerList?.map((itm) => {
          return {
            label: itm.firstName + "-" + itm.lastName,
            value: itm.consumerId,
          };
        })
      : [];

  useEffect(() => {
    getSingleTemplateData();
  }, [templateData?.templateId]);

  // get single template data
  const getSingleTemplateData = async () => {
    setTemplateLoader(true);

    try {
      const response = await apiCall({
        apiGroup: "template",
        apiRoute: "showTemplate",
        extendedRoute: `/${templateData?.templateId}`,
      });

      setData(response?.data);
      setTemplateLoader(false);
      if (response?.data?.isWhatsappPannelApprove !== "approved") {
        dispatch(setMultiMsg(false));
      }
    } catch (err) {
      console.log("Err while getting single template", err);
      setTemplateLoader(false);
    }

    // await fetch(process.env.REACT_APP_BASE_URL + `/template/show/${templateData?.templateId}`,{
    //     method:'GET',
    //     headers:{'Content-Type':'application/json'}
    // }).then((res)=>res.json())
    // .then((response)=>{
    //     setData(response?.data);
    //     setTemplateLoader(false);
    //     if(response?.data?.isWhatsappPannelApprove !== "approved"){
    //         dispatch(setMultiMsg(false));
    //     }
    // })
    // .catch((error)=>{
    //     console.log("Err while getting single template", error);
    //     setTemplateLoader(false);
    // })
  };

  // update status by admin/head ----------------------
  const updateByAdmin = async (templateId, status) => {
    setLoader(true);

    try {
      const response = await apiCall({
        apiGroup: "template",
        apiRoute: "approveTemplate",
        payload: {
          templateId: templateId,
          isApprove: status,
        },
      });

      if (response.message === "Template Approved Successfully...!") {
        toast.success("Status Approved successfully.");
        getSingleTemplateData();
        setShow(false);
        setLoader(false);
      } else if (response.message === "Template Reject Successfully...!") {
        toast.error("Status rejected.");
        setShowReject(false);
        setLoader(false);
      }else{
        toast.error(response?.message)
        setShowReject(false);
        setLoader(false);
      }


    } catch (err) {
      console.log("err", err);
      setLoader(false);
    }

    // await fetch(process.env.REACT_APP_BASE_URL + '/template/approveTemplate',{
    //     method:'POST',
    //     headers:{'Content-Type':'application/json'},
    //     body:JSON.stringify({
    //         templateId:templateId,
    //         isApprove:status
    //     })
    // }).then((res)=>res.json())
    // .then((response)=>{
    //     if(response.message=== "Template Approved Successfully...!"){
    //         toast.success("Status Approved successfully.");
    //         getSingleTemplateData()
    //         setShow(false)
    //         setLoader(false);
    //     }else if(response.message === "Template Reject Successfully...!"){
    //         toast.error("Status rejected.");
    //         getSingleTemplateData()
    //         setShowReject(false)
    //         setLoader(false);
    //     }
    // })
    // .catch((err)=>{
    //     console.log("err",err);
    //     setLoader(false);
    // })
  };

  // send message ---------------------------
  const validateVariables = () => {
    let isValid = true;

    for (let i = 0; i < variables.length; i++) {
      if (variables[i].trim() === "") {
        setVariableErrors(i, true);
        isValid = false;
      } else {
        setVariableErrors(i, false);
      }
    }

    return isValid;
  };

  const sendMesgValidate = () => {
    let isValid = true;

    if (!consumer) {
      isValid = false;
      setConsumerErr(true);
    } else if (data?.noOfVariables !== 0 && variables.length === 0) {
      isValid = false;
      setVariableErrors(true);
    } else {
      isValid = validateVariables();
    }

    return isValid;
  };

  const sendMessage = async (templateId) => {
    console.log(templateId);
    setConsumerErr(false);
    setVariableErrors(false);

    if (sendMesgValidate()) {
      setLoader(true);

      try {
        const response = await apiCall({
          apiGroup: "messenger",
          apiRoute: "sendMessage",
          payload: {
            templateId: templateId,
            templateInitateById: userData?.userId,
            templateInitateByContactNo: userData?.contactNo,
            templateInitateByName: userData?.name,
            templateInitateTime: new Date(),
            consumerId: consumer?.value,
            parameters: variables,
          },
        });

        if (response?.message === "Message sent Successfully") {
          toast.success("Message sent successfully.");
          getSingleTemplateData();
          setShowSendMsg(false);
          setLoader(false);
        } else if (
          response?.message === "No credits available for this department"
        )
          toast.error(
            "Credit point for this department is 0, please add credit point and try again."
          );
        setLoader(false);
      } catch (err) {
        console.log("err", err);
        setLoader(false);
      }

      //     await fetch(process.env.REACT_APP_BASE_URL + '/conversation/sendMessage',{
      //         method:'POST',
      //         headers:{'Content-Type':'application/json'},
      //         body:JSON.stringify({
      //             templateId : templateId,
      //             templateInitateById : userData?.userId,
      //             templateInitateByContactNo : userData?.contactNo,
      //             templateInitateByName:  userData?.name,
      //             templateInitateTime : new Date(),
      //             consumerId : consumer?.value,
      //             parameters : variables
      //         })
      //     }).then((res)=>res.json())
      //     .then((response)=>{
      //         if(response?.message === "Message sent Successfully"){
      //             toast.success("Message sent successfully.");
      //             getSingleTemplateData()
      //             setShowSendMsg(false)
      //             setLoader(false);
      //         }else if(response?.message === "No credits available for this department")
      //             toast.error("Credit point for this department is 0, please add credit point and try again.");
      //             setLoader(false);
      //     }
      // )
      //     .catch((err)=>{
      //         console.log("err",err);
      //         setLoader(false);
      //     })
    }
  };
  /* ----------------------- Handle send Multuple Msg -------------------------*/

  const handleMutliMsg = () => {
    dispatch(setMultiMsg(true));
    let scrollArray = [];
    scrollArray.push("sendMultiMsg");
    document
      .getElementById(scrollArray[0])
      ?.scrollIntoView({ behavior: "smooth" });
  };

  const getContent = (content) => {
    if (content === undefined) {
      return null;
    }

    if (data?.templateBrodcastType === "text") {
      return content;
    } else {
      let media = content[0];

      switch (media?.type.toUpperCase()) {
        case "IMAGE":
          return (
            <img
              src={media.url}
              className="templateImage"
              style={{ width: "80%", height: "auto", objectFit: "contain" }}
            />
          );
        case "VIDEO":
          return (
            <video
              src={media.url}
              className="templateVideo"
              style={{ width: "80%", height: "auto", objectFit: "contain" }}
              controls
            >
              Your browser does not support the video tag.
            </video>
          );
        case "DOCUMENT":
          return (
            <iframe
              src={media.url}
              className="templateDocument"
              style={{
                width: "80%",
                height: "300px", // Adjust as needed for viewing area
                border: "none",
              }}
              title="Document Viewer"
            >
              Your browser does not support PDFs.{" "}
              <a href={media.url}>Download PDF</a>
            </iframe>
          );
      }
    }
  };

  // Get accepted file types based on broadCastMedia
  const getAcceptedFileTypes = (mediaType) => {
    switch (mediaType) {
      case "IMAGE":
        return [".jpg", ".jpeg", ".png"];
      case "VIDEO":
        return [".mp4"];
      case "DOCUMENT":
        return [".pdf"];
      default:
        return [];
    }
  };

  // Validate file type
  const validateFileType = (file,broadCastMedia) => {
    const acceptedTypes = getAcceptedFileTypes(broadCastMedia);
    const fileExtension = file.name.split(".").pop().toLowerCase();
    return acceptedTypes.includes(`.${fileExtension}`);
  };

  const handleBroadCastMedia = async (e,broadCastMedia) => {
    setMediaLoader(true);
    const file = e.target.files[0];

    if (!file) return;

    // Validate file type
    if (!validateFileType(file,broadCastMedia)) {
      toast.error(`Invalid file type. Please select a ${broadCastMedia} file.`);
      setMediaLoader(false)
      return;
    }

    if(file.size >= MAX_FILE_SIZE){
        toast.error("File size exceeds 5MB limit. Please upload a smaller file.");
        setMediaLoader(false)
        return;  
    }

    const formData = new FormData();
    formData.append("image", file);
    formData.append("type",broadCastMedia.toLowerCase())


    const response = await fetch(
      process.env.REACT_APP_BASE_URL + "/upload/photo",
      {
        method: "POST",
        body: formData,
      }
    );

    if (!response.ok) {
      throw new Error("Upload failed");
    }

    const result = await response.json();
    if (result.url) {
      setFileName(file.name)
      let template = { ...data };
      template.content[0].url = result.url;
      template.content[0].filename = file.name
      updateTemplate(template);
    }
  };

  const updateTemplate = async (template) => {
    try {
      const response = await apiCall({
        apiGroup: "template",
        apiRoute: "updateTemplate",
        payload: template,
      });

      if (response.message === "Record Updated Successfully...!") {
        setMediaLoader(false);
        getSingleTemplateData();
      }
    } catch (err) {
      console.log("Err while adding user", err);
    }
  };

  const formatMobileNumber = (mobileNumber) => {
    // Convert to string to handle numeric inputs
    const mobileString = mobileNumber.toString();

    // Extract the last 10 digits
    const mobile = mobileString.slice(-10);

    // Extract the remaining portion (country code)
    const countryCode = mobileString.slice(0, -10);

    // Format and return the result
    return countryCode ? `${countryCode} ${mobile}` : mobile;
  };

  return (
    <div className="ViewAllDetails outletPadding">
      {/* <ToastContainer/> */}
      <div className="m-3" data-aos="fade-up" data-aos-delay="100">
        <Button
          className="primaryBtn mb-4"
          onClick={() => navigate(-1)}
          style={{ marginLeft: "5px" }}
        >
          <span>
            <Icon.ArrowLeft className="me-2" />
          </span>
          Back
        </Button>
        <div className="mt-2">
          <Table responsive="sm" bordered>
            <tbody className="mt-4">
              {templateLoader ? (
                <TableSkeleton rows={6} cols={4} />
              ) : (
                <>
                  <tr>
                    <th>Template Title</th>
                    <td>{data?.templateTitle}</td>
                    <th>Department</th>
                    <td>{data?.departmentName}</td>
                  </tr>
                  <tr>
                    <th>Variables</th>
                    <td>
                      {data?.variable.length > 0
                        ? data?.variable?.map((row) => row).join(", ")
                        : "-"}
                    </td>
                    <th>Created By</th>
                    <td>{data?.createdBy}</td>
                  </tr>
                  <tr>
                    <th>Variable Counts</th>
                    <td>{data?.noOfVariables}</td>
                    <th>Category</th>
                    <td>{data?.category}</td>
                  </tr>
                  <tr>
                    <th>Message</th>
                    <td style={{ width: "50%" }}>{data?.message}</td>
                    <th>Admin Approval</th>
                    <td>
                      <h6
                        className={
                          data?.isApprove === "Pending"
                            ? "pending"
                            : data?.isApprove === "Approve"
                            ? "approve"
                            : data?.isApprove === "Reject"
                            ? "reject"
                            : ""
                        }
                      >
                        {data?.isApprove === "Pending"
                          ? "Pending"
                          : data?.isApprove === "Approve"
                          ? "Approved"
                          : data?.isApprove === "Reject"
                          ? "Rejected"
                          : ""}
                      </h6>
                    </td>
                  </tr>
                  <tr>
                    <th>Credit Point</th>
                    <td>{data?.credits ? data?.credits : "0"}</td>
                    <th>WhatsApp Panel Approval</th>
                    <td>
                      <h6
                        className={
                          data?.isWhatsappPannelApprove === "pending" ||
                          data?.isWhatsappPannelApprove === "submitted"
                            ? "pending"
                            : data?.isWhatsappPannelApprove === "approved"
                            ? "approve"
                            : data?.isWhatsappPannelApprove === "rejected"
                            ? "reject"
                            : ""
                        }
                      >
                        {data?.isWhatsappPannelApprove === "pending" ||
                        data?.isWhatsappPannelApprove === "submitted"
                          ? "Pending"
                          : data?.isWhatsappPannelApprove === "approved"
                          ? "Approved"
                          : data?.isWhatsappPannelApprove === "rejected"
                          ? "Rejected"
                          : " "}
                      </h6>
                    </td>
                  </tr>
                  <tr>
                    <th>Created Date</th>
                    <td>{moment(data?.createdDate).format("DD-MM-YYYY")}</td>
                    <th>Channel End Date</th>
                    <td>{moment(data?.channelEndDate).format("DD-MM-YYYY")}</td>
                  </tr>
                  <tr>
                    <th>Template Content</th>
                    <td>
                      {medialoader ? (
                        <Spinner size="sm" variant="primary" />
                      ) : (
                        <Row className="d-flex align-items-center">
                          <Col md={8}>{getContent(data?.content)}</Col>
                          <Col md={4}>
                            {data?.templateBrodcastType === "media" ? (
                              <>
                                <input
                                  type="file"
                                  id="fileInput"
                                  style={{ display: "none" }}
                                  onChange={(e) => handleBroadCastMedia(e,data?.content[0]?.type)}
                                />
                                <label
                                  htmlFor="fileInput"
                                  className="mediaButton"
                                >
                                  Upload Media
                                </label>
                              </>
                            ) : null}
                          </Col>
                        </Row>
                      )}
                    </td>
                    <th>Template BroadCast Type</th>
                    <td>{data?.templateBrodcastType !== "" ? data?.templateBrodcastType : "-"}</td>
                  </tr>
                  <tr>
                    <th>Template Footer</th>
                    <td colSpan={3}>
                      {data?.footerText !== "" ? data?.footerText : "-"}
                    </td>
                  </tr>
                  { data?.buttons && data?.buttons.length > 0 ? (
                    <tr>
                      <th>Template Buttons</th>
                      <td colSpan={3}>
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Type</th>
                              <th>Text</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data?.buttons.map((button, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{button.type.replace("_", " ")}</td>
                                <td>{button.text}</td>
                                <td>
                                  {button.type === "URL" ? (
                                    <a
                                      href={button.url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Visit URL
                                    </a>
                                  ) : button.type === "PHONE_NUMBER" ? (
                                    <a href={`tel:${button.phone_number}`}>
                                      {formatMobileNumber(button.phone_number)}
                                    </a>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  ) : null}
                </>
              )}
            </tbody>
          </Table>
        </div>

        <Row className="justify-content-center mt-4">
          <div className="d-flex flex-column flex-md-row justify-content-center text-center">
            {data?.isApprove === "Approve" &&
              (data?.isWhatsappPannelApprove === "pending" ||
                data?.isWhatsappPannelApprove === "submitted") && (
                <h6 style={{ fontWeight: "600", color: "red" }}>
                  Note : Please wait for Whatsapp Panel approval to send a
                  message.
                </h6>
              )}
            {data?.isWhatsappPannelApprove === "rejected" && (
              <h6 style={{ fontWeight: "600", color: "red" }}>
                Note : Your template has been rejected.
              </h6>
            )}

            {data?.isApprove === "Pending" && (
              <>
                <Button
                  className="approveBtn mb-3 mb-md-0 me-0 me-md-4"
                  onClick={() => setShow(true)}
                >
                  <Icon.CheckCircle className="me-2" />
                  Status Approve
                </Button>
                <Button
                  className="rejectBtn mb-3 mb-md-0"
                  onClick={() => setShowReject(true)}
                >
                  <Icon.XCircle className="me-2" />
                  Status Reject
                </Button>
              </>
            )}

            {data?.isWhatsappPannelApprove === "approved" && (
              <>
                <Button
                  className="primaryBtn mb-3 mb-md-0 ms-0 ms-md-4"
                  onClick={() => setShowSendMsg(true)}
                >
                  <Icon.Send className="me-2" />
                  Send Single Message
                </Button>
                <Button
                  className="primaryBtn ms-0 ms-md-4"
                  onClick={() => {
                    handleMutliMsg();
                  }}
                >
                  <Icon.SendPlus className="me-2" /> Send Multiple Messages
                </Button>
              </>
            )}
          </div>
        </Row>
      </div>

      {/* ---------------------- Send Multiple Message ------------------------ */}
      {multiMsg && data && (
        <div
          data-aos="fade-up"
          id="sendMultiMsg"
          style={{ scrollMarginTop: "-50vh" }}
        >
          <SendMultipleMsg data={data} />
        </div>
      )}

      {/* ------Approve status Modal--------- */}
      <Modal
        size="md"
        show={show}
        backdrop="static"
        keyboard={false}
        centered
        onHide={() => setShow(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {" "}
            <h4 className="mb-0">
              <Icon.CheckCircle size={20} className="me-2" />
              Approve Status
            </h4>{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="justify-content-center">
          <Row>
            <h6>Are you sure you want to approve the status !</h6>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="approveBtn"
            disabled={loader}
            onClick={() => updateByAdmin(data?.templateId, "Approve")}
          >
            {loader ? (
              <Spinner size="sm" />
            ) : (
              <Icon.CheckCircle className="me-2" />
            )}
            Approve
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------Reject status Modal--------- */}
      <Modal
        size="md"
        show={showReject}
        backdrop="static"
        keyboard={false}
        centered
        onHide={() => setShowReject(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {" "}
            <h4 className="mb-0">
              <Icon.XCircle size={20} className="me-2" />
              Reject Status
            </h4>{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="justify-content-center">
          <Row>
            <h6>Are you sure you want to reject the status !</h6>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="rejectBtn"
            disabled={loader}
            onClick={() => updateByAdmin(data?.templateId, "Reject")}
          >
            {loader ? <Spinner size="sm" /> : <Icon.XCircle className="me-2" />}
            Reject
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ---------send message modal------ */}
      <Modal
        size="lg"
        show={showSendMsg}
        backdrop="static"
        keyboard={false}
        centered
        onHide={() => setShowSendMsg(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {" "}
            <h4 className="mb-0">
              <Icon.Send size={20} className="me-2" />
              Send Message
            </h4>{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="justify-content-center">
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Template Title</Form.Label>
                <Form.Control value={data?.templateTitle}></Form.Control>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Consumer Name</Form.Label>
                <Select
                  options={consumerData}
                  onChange={(selected) => {
                    setConsumerErr(false);
                    setConsumer(selected);
                  }}
                />
                {consumerErr ? (
                  <p className="errMsg">Please select consumer</p>
                ) : (
                  ""
                )}
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Message</Form.Label>
                <Form.Control as="textarea" rows={4} value={data?.message} />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>No of Variables</Form.Label>
                <Form.Control value={data?.noOfVariables} />
              </Form.Group>
            </Col>

            <Row>
              {variables?.map((variable, index) => (
                <Col md={4}>
                  <Form.Group
                    key={index}
                    className="mb-3"
                    style={{ display: "inline-block", marginRight: "10px" }}
                  >
                    <Form.Label>{`Variable ${index + 1}`}</Form.Label>
                    <Form.Control
                      type="text"
                      value={variable}
                      name="parameters"
                      onChange={(e) => {
                        const updatedVariables = [...variables];
                        updatedVariables[index] = e.target.value;
                        setVariables(updatedVariables);

                        const updatedErrors = [...variableErrors];
                        if (e.target.value.trim() === "") {
                          updatedErrors[index] = true;
                        } else {
                          updatedErrors[index] = false;
                        }
                        setVariableErrors(updatedErrors);
                      }}
                    />
                    {variableErrors[index] && (
                      <p className="errMsg">
                        Variable {index + 1} cannot be empty
                      </p>
                    )}
                  </Form.Group>
                </Col>
              ))}
            </Row>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="primaryBtn"
            disabled={loader}
            onClick={() => sendMessage(data?.templateId, data?.credits)}
          >
            {loader ? <Spinner size="sm" /> : <Icon.Send className="me-2" />}
            Send Message
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
